import RouteNameEnum from '@/router/RouteNameEnum';
import { FunnelStep } from '../FunnelStep';
import store from '@/store/BookingStore';
import { hanldeSecureless } from '../middleware/hanldeSecureless';
import getQueryParams from '@/utils/getQueryParams';
import { BookingFunnelService } from '@/service/BookingFunnelService/BookingFunnelService';
import { StatusV2 } from '../../../../../requests-module/src';
import { startGlobalPollingFlight } from '@/composables/pollingFlightController';
import checkIsPackageFlight from '@/logic/options/checkIsPackageFlight';
import subscribeToCRMnewsLetter from '@/logic/contact/subscribeToCRMnewsLetter';
import { OrchestratorService } from '@/logic/payment/stripe/v2/OrchestratorService';

export const paymentStep = new FunnelStep({
    name: RouteNameEnum.PaymentV2,
    dependencies: [],
    init: async () => {
        console.log('init(): Initializing Payment Page - if logged in - refresh');
        // has bo, make a refresh call with alt options
        const response = await BookingFunnelService.refreshBookingOptions()
        console.log('init(): Initializing Payment Page - if logged out, no need for a refresh call, just a a login form.');

        if ('error' in response) {
            throw new Error('Error with api')
        }
        if (checkIsPackageFlight(store.getters.getBooking)) {
            startGlobalPollingFlight(store.getters.getBooking.boReference);
        }
        console.log('store.getters.getIsSubscribeNewsletter', store.getters.getIsSubscribeNewsletter);
        if (store.getters.getIsSubscribeNewsletter.email || store.getters.getIsSubscribeNewsletter.sms)
            await subscribeToCRMnewsLetter(store.getters.getEmail, store.getters.getIsSubscribeNewsletter.email, store.getters.getIsSubscribeNewsletter.sms)

        const orchestratorService = new OrchestratorService()
        await orchestratorService.notify()

        if (response.status == StatusV2.SUCCESS) {
            return '/success'
        }

        return false
    },
    hasToBeLoggedIn: true
});